import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './CardView.css';

const CardView = () => {
  const { cardId } = useParams();
  const [recipientName, setRecipientName] = useState("Loading...");
  const [isAccepted, setIsAccepted] = useState(false);
  const [noButtonPos, setNoButtonPos] = useState({ top: '50%', left: '60%' });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const BACKEND_API_URL = process.env.REACT_APP_BACKEND_API_URL;
  useEffect(() => {
    if (!cardId) {
      setError(true);
      setLoading(false);
      return;
    }
    const fetchCard = async () => {
      try {
        const response = await fetch(`${BACKEND_API_URL}/api/card/${cardId}`);
        
        if (response.status === 404) {
          setError(true);
          setLoading(false);
          return;
        }
        console.log(response);
        const data = await response.json();
       
        setRecipientName(data.recipientName);
        setLoading(false);
      } catch (err) {
        setError(true);
        setLoading(false);
      }
    };

    fetchCard();
  }, [cardId,BACKEND_API_URL]);

  // 2. The Jump Logic
  const handleNoInteraction = () => {
    // Generate random position between 10% and 80% to keep it on screen
    const randomTop = Math.floor(Math.random() * 70) + 10;
    const randomLeft = Math.floor(Math.random() * 70) + 10;
    setNoButtonPos({ top: `${randomTop}%`, left: `${randomLeft}%` });
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="heart-spinner"></div>
        <p className="loading-text">Opening your surprise...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-page">
        <div className="broken-heart">💔</div>
        <h1>Oops! Page Not Found</h1>
        <p>This Valentine link is invalid or has expired.</p>
      </div>
    );
  }

  return (
    <div className="card-wrapper">
      {!isAccepted ? (
        <div className="game-container">
          <div className="floating-hearts">💖</div>
          <h1 className="valentine-question">
            Will you be my Valentine, <span className="highlight">{recipientName}</span>?
          </h1>

          <div className="button-canvas">
            {/* YES BUTTON */}
            <button 
              className="btn-yes" 
              onClick={() => setIsAccepted(true)}
            >
              Yes! 🥰
            </button>

            {/* NO BUTTON (The Runaway) */}
            <button 
              className="btn-no"
              style={{ 
                position: 'fixed', 
                top: noButtonPos.top, 
                left: noButtonPos.left,
                transition: 'all 0.15s ease-out' 
              }}
              onMouseEnter={handleNoInteraction} // Desktop hover
              onClick={handleNoInteraction}      // Mobile tap
            >
              No 😢
            </button>
          </div>
        </div>
      ) : (
        <div className="success-screen animate-pop">
          <h1 className="success-text">I knew you'd say Yes! ❤️</h1>
          {/* REPLACE THE URL BELOW WITH YOUR CHOSEN GIF LATER */}
          <div className="gif-container">
            <img 
              src="https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExc2Jubmh1anN0OW4zY2swbG9nNzFta2F3amVtc24ycWR0a3Y1MXU3ZiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/MDJ9IbxxvDUQM/giphy.gif"
              alt="Happy Celebration" 
              className="celebration-gif"
            />
          </div>
          <p className="footer-msg">Sending lots of love your way!</p>
        </div>
      )}
    </div>
  );
};

export default CardView;